module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "user.66199745.svg";